/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type MessageBanner_viewer$ref: FragmentReference;
export type MessageBanner_viewer = {|
  +messages?: ?$ReadOnlyArray<?{|
    +items: ?$ReadOnlyArray<?{|
      +impressionCap: ?number,
      +note: ?{|
        +serviceId: ?string,
        +content: ?{|
          +title: ?string,
          +message: ?string,
          +cta: ?{|
            +text: ?string,
            +url: ?string,
          |},
        |},
        +anchors: ?$ReadOnlyArray<?{|
          +serviceId: ?string,
          +content: ?{|
            +title: ?string,
            +message: ?string,
            +cta: ?{|
              +text: ?string,
              +url: ?string,
            |},
          |},
        |}>,
      |},
    |}>
  |}>,
  +allTransactions?: ?{|
    +totalResults: ?number
  |},
  +initiatedTransactions?: ?{|
    +totalResults: ?number
  |},
  +submittedTransactions?: ?{|
    +totalResults: ?number
  |},
  +confirmedTransactions?: ?{|
    +totalResults: ?number
  |},
  +$refType: MessageBanner_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userIds",
  "type": "[String]"
},
v1 = {
  "kind": "Literal",
  "name": "first",
  "value": 0,
  "type": "Int"
},
v2 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "totalResults",
    "args": null,
    "storageKey": null
  }
],
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "content",
  "storageKey": null,
  "args": null,
  "concreteType": "MarketingMessageContent",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "message",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "cta",
      "storageKey": null,
      "args": null,
      "concreteType": "MarketingMessageCta",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "text",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "url",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
return {
  "kind": "Fragment",
  "name": "MessageBanner_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "hasUserType",
      "type": "Boolean!",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "setId",
      "type": "String!",
      "defaultValue": ""
    },
    {
      "kind": "LocalArgument",
      "name": "userType",
      "type": "String!",
      "defaultValue": ""
    },
    {
      "kind": "RootArgument",
      "name": "userIds",
      "type": "[String]"
    },
    {
      "kind": "RootArgument",
      "name": "fetchMarketingMessagesTransactions",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchMarketingMessagesTransactions",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "allTransactions",
          "name": "transactions",
          "storageKey": null,
          "args": [
            (v0/*: any*/),
            (v1/*: any*/)
          ],
          "concreteType": "TransactionConnection",
          "plural": false,
          "selections": (v2/*: any*/)
        },
        {
          "kind": "LinkedField",
          "alias": "initiatedTransactions",
          "name": "transactions",
          "storageKey": null,
          "args": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "kind": "Literal",
              "name": "viewName",
              "value": "buyerTracking.initiated",
              "type": "String"
            }
          ],
          "concreteType": "TransactionConnection",
          "plural": false,
          "selections": (v2/*: any*/)
        },
        {
          "kind": "LinkedField",
          "alias": "submittedTransactions",
          "name": "transactions",
          "storageKey": null,
          "args": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "kind": "Literal",
              "name": "viewName",
              "value": "buyerTracking.submitted",
              "type": "String"
            }
          ],
          "concreteType": "TransactionConnection",
          "plural": false,
          "selections": (v2/*: any*/)
        },
        {
          "kind": "LinkedField",
          "alias": "confirmedTransactions",
          "name": "transactions",
          "storageKey": null,
          "args": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "kind": "Literal",
              "name": "sort",
              "value": "createdDate asc",
              "type": "String"
            },
            {
              "kind": "Literal",
              "name": "viewName",
              "value": "buyerTracking.confirmed",
              "type": "String"
            }
          ],
          "concreteType": "TransactionConnection",
          "plural": false,
          "selections": (v2/*: any*/)
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasUserType",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "messages",
          "name": "messageSet",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "setId",
              "variableName": "setId",
              "type": "String"
            },
            {
              "kind": "Variable",
              "name": "userType",
              "variableName": "userType",
              "type": "String!"
            }
          ],
          "concreteType": "MessageSetModule",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "items",
              "storageKey": null,
              "args": null,
              "concreteType": "MessageSetItem",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "impressionCap",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "note",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "MarketingMessage",
                  "plural": false,
                  "selections": [
                    (v3/*: any*/),
                    (v4/*: any*/),
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "anchors",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "MarketingMessage",
                      "plural": true,
                      "selections": [
                        (v3/*: any*/),
                        (v4/*: any*/)
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ad5fcbf12d3cd704f198e843894213bd';
module.exports = node;
